"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIVILEGES_DEFAULTS = exports.PrivilegeTypes = void 0;
var PrivilegeTypes;
(function (PrivilegeTypes) {
    PrivilegeTypes["DISPATCH_SCREEN"] = "dispatch";
    PrivilegeTypes["CREATE_ORDERS"] = "create_order";
    PrivilegeTypes["VIEW_TASK"] = "view_task";
    PrivilegeTypes["ACKNOWLEDGE_FLOW"] = "acknowledge";
    PrivilegeTypes["HISTORY"] = "history";
    PrivilegeTypes["DRIVERS"] = "drivers";
    PrivilegeTypes["DRIVER_PRORFILE"] = "driver_profile";
    PrivilegeTypes["ADD_DRIVER"] = "add_driver";
    PrivilegeTypes["CHANGE_DRIVER_ROLE"] = "change_driver_type";
    PrivilegeTypes["ASSIGN_DRIVER_TO_TASK"] = "assign_driver_to_task";
    PrivilegeTypes["TEAMS"] = "teams";
    PrivilegeTypes["USER_TYPES"] = "user_types";
    PrivilegeTypes["CUSTOMERS"] = "customers_menu";
    PrivilegeTypes["REPORTS"] = "reports";
    PrivilegeTypes["REPORTS_NEW"] = "reports_new";
    PrivilegeTypes["DASHBOARD"] = "dashboard";
    PrivilegeTypes["CASHOUT_EDIT_DISTANCE"] = "cashout_edit_distance";
    PrivilegeTypes["ACCESS_SETTINGS_SCREEN"] = "access_settings_screen";
    PrivilegeTypes["ENABLE_SETTING_PAGE"] = "enable_setting_page";
    PrivilegeTypes["CUSTOMER_CARE"] = "customer_care";
    PrivilegeTypes["MAINTAIN_DRIVER_SHIFT_TIMES"] = "maintain_driver_shift_times";
    PrivilegeTypes["COMPLETE_TASK"] = "complete_task";
    PrivilegeTypes["EDIT_DELIVERY_BLOCK"] = "edit_delivery_block";
    PrivilegeTypes["SEE_SEND_TO_PREPARATION"] = "send_to_preparation";
    PrivilegeTypes["ACCESS_TASKS"] = "access_task";
    PrivilegeTypes["ACCESS_TO_ALL_TASKS"] = "access_to_all_tasks";
    PrivilegeTypes["ACCESS_COMPANY_TASKS_ONLY"] = "access_company_tasks_only";
    PrivilegeTypes["EDIT_COMPANY"] = "edit_company";
    PrivilegeTypes["ENABLE_BI_DASHBOARD"] = "enable_bi_dashboard";
    PrivilegeTypes["EDIT_EXCLUSION_WINDOWS"] = "edit_exclusion_windows";
    PrivilegeTypes["EDIT_TASK_DETAILS"] = "edit_task_details";
    PrivilegeTypes["TASKS_CSV_IMPORTER_EDIT_HEADERS"] = "tasks_csv_importer_edit_headers";
    PrivilegeTypes["EDIT_SERVICE_AREAS"] = "edit_service_areas";
    PrivilegeTypes["ACCESS_USERS"] = "access_user";
    PrivilegeTypes["ACCESS_COMPANY_USERS_ONLY"] = "access_company_users_only";
    PrivilegeTypes["ACCESS_TO_NONE_ORDERS"] = "access_to_none_orders";
    PrivilegeTypes["CANCEL_TASK"] = "cancel_task";
    PrivilegeTypes["LOCK_UNLOCK_TASK"] = "lock_unlock_task";
    PrivilegeTypes["RESCHEDULE_CANCELLED_ORDER"] = "reschedule_cancelled_order";
    PrivilegeTypes["BILLING_PORTAL"] = "billing_portal";
    PrivilegeTypes["CUSTOMIZE_LIST_LAYOUT"] = "customize_list_layout";
    PrivilegeTypes["ENABLE_ALERT_DISPLAY_NEW_FILTERS"] = "enable_alert_display_new_filters";
    PrivilegeTypes["VIEW_CONSUMER_VERIFICATION_CODE"] = "view_consumer_verification_code";
    PrivilegeTypes["EDIT_ANALYTICS_MASTER_DASHBOARD"] = "edit_analytics_master_dashboard";
    PrivilegeTypes["IS_ANALYTICS_ADMIN"] = "is_analytics_admin";
    PrivilegeTypes["SHARE_ANALYTICS_REPORTS"] = "share_analytics_reports";
    PrivilegeTypes["SHARE_ANALYTICS_BI_DASHBOARDS"] = "share_analytics_dashboards";
    PrivilegeTypes["CREATE_ANALYTICS_BI_DASHBOARDS"] = "create_analytics_bi_dashboards";
    PrivilegeTypes["ALLOW_DISPATCHER_CREATE_VEHICLE"] = "allow_dispatcher_create_vehicle";
    PrivilegeTypes["ALLOW_DISPATCHER_EDIT_SERVICE_AREA"] = "allow_dispatcher_edit_service_area";
    PrivilegeTypes["SEND_TO_DRIVERS"] = "send_to_drivers";
    PrivilegeTypes["OPTIMIZE_ORDERS"] = "optimize_orders";
    PrivilegeTypes["ASSIGN_USER_TO_COMPANY"] = "assign_user_to_company";
    PrivilegeTypes["ENABLE_WEBHOOKS"] = "enable_webhooks";
    PrivilegeTypes["ENABLE_MERCHANT_LOGS"] = "enable_merchant_logs";
    PrivilegeTypes["ENABLE_SELF_ASSIGNMENT_TO_TEAMS"] = "enable_self_assignment_to_teams";
    PrivilegeTypes["ENABLE_CHAT"] = "enable_chat";
    PrivilegeTypes["ALLOW_ASSIGN_VEHICLE_TO_RUN"] = "allow_assign_vehicle_to_run";
    PrivilegeTypes["REASSIGN_FLEET"] = "reassign_fleet";
    PrivilegeTypes["SHARE_ANALYTICS_DASHBOARDS"] = "share_analytics_dashboards";
    PrivilegeTypes["MODIFY_PLANNED_ROUTE_IDENTIFIER"] = "modify_planned_route_identifier";
    PrivilegeTypes["FLOATING_INVENTORY_TAKE_OWNERSHIP_FROM_DRIVER"] = "floating_inventory_take_ownership_from_driver";
    PrivilegeTypes["FLOATING_INVENTORY_TRANSFER_OWNERSHIP_TO_TEAM"] = "floating_inventory_transfer_ownership_to_team";
    PrivilegeTypes["IS_CHAT_ADMIN"] = "is_chat_admin";
    PrivilegeTypes["MANUAL_ORDER_FULFILLMENT"] = "manual_order_fulfillment";
    PrivilegeTypes["ALLOW_USING_ROUTE_PLANNER_IN_DISPATCH"] = "allow_using_route_planner_in_dispatch";
    PrivilegeTypes["ALLOW_USING_ROUTE_PLANNER_IN_PLANNING"] = "allow_using_route_planner_in_planning";
})(PrivilegeTypes || (exports.PrivilegeTypes = PrivilegeTypes = {}));
exports.PRIVILEGES_DEFAULTS = (_a = {},
    _a[PrivilegeTypes.CANCEL_TASK] = true,
    _a[PrivilegeTypes.LOCK_UNLOCK_TASK] = true,
    _a[PrivilegeTypes.RESCHEDULE_CANCELLED_ORDER] = true,
    _a[PrivilegeTypes.SEND_TO_DRIVERS] = true,
    _a[PrivilegeTypes.OPTIMIZE_ORDERS] = true,
    _a[PrivilegeTypes.EDIT_TASK_DETAILS] = true,
    _a[PrivilegeTypes.ENABLE_CHAT] = true,
    _a[PrivilegeTypes.SHARE_ANALYTICS_REPORTS] = true,
    _a[PrivilegeTypes.CREATE_ANALYTICS_BI_DASHBOARDS] = true,
    _a[PrivilegeTypes.MODIFY_PLANNED_ROUTE_IDENTIFIER] = true,
    _a[PrivilegeTypes.FLOATING_INVENTORY_TRANSFER_OWNERSHIP_TO_TEAM] = true,
    _a[PrivilegeTypes.ALLOW_USING_ROUTE_PLANNER_IN_DISPATCH] = true,
    _a[PrivilegeTypes.ALLOW_USING_ROUTE_PLANNER_IN_PLANNING] = true,
    _a);
//# sourceMappingURL=privilege.js.map